import React, { useState, useEffect } from 'react'
import NoImageAvailable from './../setupProcess/selectYourLocation/images/noImageAvailable.jpeg'
import { GpButton } from '../components/gp'

const PropertyCard = (props) => {
    const [selected, setSelected] = useState(false)

    useEffect(() => {
        if (props.selectedProperty) {
            setSelected(props.selectedProperty[0].name === props.property?.name)
        }
    }, [props.property?.name, props.selectedProperty])

    const imgUrl = props.property?.hero?.[2]?.url || NoImageAvailable

    return (
        <div
            style={{
                background: 'var(--gp-card)',
                border: selected
                    ? '2px solid var(--gp-brand)'
                    : '1px solid var(--gp-hairline)',
                borderRadius: 'var(--gp-r-md)',
                boxShadow: 'var(--gp-shadow-sm)',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
            }}
        >
            <div
                style={{
                    width: '100%',
                    aspectRatio: '4 / 3',
                    overflow: 'hidden',
                    background: 'var(--gp-surface)',
                }}
            >
                <img
                    alt={props.property?.name || 'property'}
                    src={imgUrl}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'block',
                    }}
                />
            </div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 10,
                    padding: '12px 14px 14px',
                }}
            >
                <div
                    style={{
                        font: 'var(--gp-body-med)',
                        color: 'var(--gp-ink)',
                        textAlign: 'center',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        width: '100%',
                    }}
                >
                    {props.property?.name}
                </div>
                <GpButton
                    variant={selected ? 'primary' : 'ghost'}
                    onClick={() => props.selectThis(props.property?.name)}
                    style={{ height: 36, padding: '0 16px', fontSize: 13 }}
                >
                    {selected ? (
                        <>
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <polyline points="20 6 9 17 4 12" />
                            </svg>
                            Selected
                        </>
                    ) : (
                        'Select'
                    )}
                </GpButton>
            </div>
        </div>
    )
}

export default PropertyCard
